import { EntityReport4det } from "../../entity/EntityReport4det";

export class DtoReport4detsPutRes extends EntityReport4det {}
